module.exports = __webpack_public_path__ + "img/danse macabre.803f5571.png";